module.exports = __webpack_public_path__ + "static/media/icons8_Calculator.42247956.svg";